<template>
  <h3>eSignatures</h3>
  <esignature-maintenance/>
</template>

<script lang="ts">
import { EsignatureMaintenance } from "mail-merge/mail-merge.globals";
import { defineComponent } from "vue";

export default defineComponent({
  components: { EsignatureMaintenance },
});
</script>
